import React, { useState } from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom'

import NavLinks from './NavLinks'
import MainHeader from './MainHeader'
import SideDrawer from './SideDrawer'
import Backdrop from '../UIElements/Backdrop'

import './MainNavigation.css'

const MainNavigation = (props) => {
  const [DrawerIsOpen, setDrawerIsOpen] = useState(false)

  const openDrawerHandler = () => {
    setDrawerIsOpen(true)
  }

  const closeDrawerHandler = () => {
    setDrawerIsOpen(false)
  }

  return (
    <React.Fragment>
      {DrawerIsOpen ? <Backdrop onClick={closeDrawerHandler} /> : null}
      <SideDrawer show={DrawerIsOpen} onClick={closeDrawerHandler}>
        <nav className="main-navigation__drawer-nav">
          <NavLinks />
        </nav>
      </SideDrawer>
      <MainHeader>
        <button
          className="main-navigation__menu-btn"
          onClick={openDrawerHandler}
        >
          <span />
          <span />
          <span />
        </button>
        <h1 className="main-navigation__title">
          <Link to="/">Your places</Link>
        </h1>
        <div className="main-navigation__spacer" />
        <button
          className="main-navigation__theme-btn"
          onClick={() => window.__toggleTheme && window.__toggleTheme()}
          aria-label="Toggle theme"
        >
          <span className="theme-dot" />
        </button>
        <nav className="main-navigation__header-nav">
          <NavLinks />
        </nav>
      </MainHeader>
    </React.Fragment>
  )
}

export default MainNavigation
